export default __webpack_public_path__ + "static/media/paddle.754155d0.svg";